<template>
  <DsShowcase title="StarRatingPlay" description="Componente de avaliação por estrelas com hover, tamanho customizável e modo readonly.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model:rating</code></p>
      <div class="tw:space-y-3">
        <StarRatingPlay :rating="rating1" @update:rating="rating1 = $event" />
        <p class="tw:text-xs tw:opacity-50">Nota: {{ rating1 }}</p>
      </div>
    </section>

    <!-- PROP: maxRating -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">maxRating</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — quantidade de estrelas. Padrão: <code>5</code></p>
      <div class="tw:space-y-3">
        <StarRatingPlay :rating="3" :max-rating="3" :read-only="true" />
        <StarRatingPlay :rating="4" :max-rating="5" :read-only="true" />
        <StarRatingPlay :rating="7" :max-rating="10" :read-only="true" />
      </div>
    </section>

    <!-- PROP: starSize -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">starSize</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>number</code> — tamanho em px. Padrão: <code>20</code></p>
      <div class="tw:space-y-3">
        <StarRatingPlay :rating="4" :star-size="14" :read-only="true" />
        <StarRatingPlay :rating="4" :star-size="20" :read-only="true" />
        <StarRatingPlay :rating="4" :star-size="32" :read-only="true" />
        <StarRatingPlay :rating="4" :star-size="48" :read-only="true" />
      </div>
    </section>

    <!-- PROP: showRating -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">showRating</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — exibe o número da nota ao lado. Padrão: <code>true</code></p>
      <div class="tw:space-y-3">
        <StarRatingPlay :rating="4" :show-rating="true" :read-only="true" />
        <StarRatingPlay :rating="4" :show-rating="false" :read-only="true" />
      </div>
    </section>

    <!-- PROP: readOnly -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">readOnly</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — desabilita interação (só exibe)</p>
      <div class="tw:space-y-3">
        <StarRatingPlay :rating="3" :read-only="true" :star-size="24" />
        <p class="tw:text-xs tw:opacity-50">Não é possível alterar (readonly)</p>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { StarRatingPlay } from '@/components/atomic'

const rating1 = ref(3)
</script>
